import getters from "@/store/getters";
import mocks from "@/__mocks__/store-mock";
import { PCG7 } from "@/config/constants";

describe("getters", () => {
  const state = mocks.state;

  it("getRoute returns correct value", () => {
    const result = getters.getRoute(state)();
    expect(result).toEqual(state.route);
  });

  it("getMock returns correct value", () => {
    const result = getters.getMock(state)();
    expect(result).toEqual(state.mock);
  });

  it("getConfirmarRenaper returns correct value", () => {
    const result = getters.getConfirmarRenaper(state)();
    expect(result).toEqual(state.confirmarRenaper);
  });

  it("getPaso1 returns correct value", () => {
    const result = getters.getPaso1(state)();
    expect(result).toEqual(state.paso1);
  });

  it("getPaso2 returns correct value", () => {
    const result = getters.getPaso2(state)();
    expect(result).toEqual(state.paso2);
  });

  it("getPaso3 returns correct value", () => {
    const result = getters.getPaso3(state)();
    expect(result).toEqual(state.paso3);
  });

  it("getPaso4 returns correct value", () => {
    const result = getters.getPaso4(state)();
    expect(result).toEqual(state.paso4);
  });

  it("getSucursal returns correct value", () => {
    const result = getters.getSucursal(state)();
    expect(result).toEqual(state.sucursal);
  });

  it("getSucursales returns correct value", () => {
    const result = getters.getSucursales(state)();
    expect(result).toEqual(state.sucursales);
  });

  it("getTieneCoordenadas returns incorrect value", () => {
    const result = getters.getTieneCoordenadas(state)();
    expect(result).toEqual(false);
  });

  it("getTieneCoordenadas returns correct value", () => {
    state.domicilio.coorX = "-58.392801";
    state.domicilio.coorY = "-34.593310";
    const result = getters.getTieneCoordenadas(state)();
    expect(result).toEqual(true);
  });

  it("getCBU returns correct value", () => {
    const result = getters.getCBU(state)();
    expect(result).toEqual(state.graciasCA.cbu);
  });

  it("getCBUPaq returns correct value", () => {
    const result = getters.getCBUPaq(state)();
    expect(result).toEqual(state.gracias.cbu);
  });

  it("getCBUcontratacion returns correct value", () => {
    const result = getters.getCBUcontratacion(state)();
    expect(result).toEqual(state.respuestaContratacion.cbu);
  });

  it("getTCode returns correct value", () => {
    const result = getters.getTCode(state)();
    expect(result).toEqual(state.tcode);
  });

  it("getStatusSocialNet returns correct value", () => {
    const result = getters.getStatusSocialNet(state)();
    expect(result).toEqual(state.socialNet.status);
  });

  it("getConsulta returns correct value", () => {
    const result = getters.getConsulta(state)();
    expect(result).toEqual(state.consulta);
  });

  it("getForzarDNE returns correct value", () => {
    const result = getters.getForzarDNE(state)();
    expect(result).toEqual(state.forzarDNE);
  });

  it("getPaquetesBeneficios returns correct value", () => {
    const result = getters.getPaquetesBeneficios(state)();
    expect(result).toEqual(state.paquetesBeneficios);
  });

  it("getOferta returns correct value", () => {
    const result = getters.getOferta(state)();
    expect(result).toEqual(state.dataOferta.oferta);
  });

  it("getAdobeTargetExperience returns correct value", () => {
    const result = getters.getAdobeTargetExperience(state)();
    expect(result).toEqual(state.adobeTargetExperience);
  });

  it("getDataOferta returns correct value", () => {
    const result = getters.getDataOferta(state)();
    expect(result).toEqual(state.dataOferta);
  });

  it("getDataQuery returns correct value", () => {
    const result = getters.getDataQuery(state)();
    expect(result).toEqual(state.dataQuery);
  });

  it("getValidacionDomicilio returns correct value", () => {
    const result = getters.getValidacionDomicilio(state)();
    expect(result).toEqual({
      randomKey: state.dataOferta.randomkey,
      domicilio: {
        calle: state.paso1.domicilioParticular.calle,
        numero: state.paso1.domicilioParticular.numero,
        piso: state.paso1.domicilioParticular.piso,
        departamento: state.paso1.domicilioParticular.dpto,
        codigoPostal: state.paso1.domicilioParticular.codigoPostal,
        localidad: state.paso1.domicilioParticular.localidad,
        provincia: state.paso1.domicilioParticular.codProvincia
      }
    });
  });

  it("getValidacionDomicilioOtro returns correct value", () => {
    const result = getters.getValidacionDomicilioOtro(state)();
    expect(result).toEqual({
      randomKey: state.dataOferta.randomkey,
      domicilio: {
        calle: state.paso4.domicilioParticular.calle,
        numero: state.paso4.domicilioParticular.numero,
        piso: state.paso4.domicilioParticular.piso,
        departamento: state.paso4.domicilioParticular.dpto,
        codigoPostal: state.paso4.domicilioParticular.codigoPostal,
        localidad: state.paso4.domicilioParticular.localidad,
        provincia: state.paso4.domicilioParticular.codProvincia
      }
    });
  });

  it("getSearchEncontesa returns correct value", () => {
    const result = getters.getSearchEncontesa(state)();
    expect(result).toEqual(state.searchEncontesa);
  });

  it("getConfirmacionData returns correct value", () => {
    const result = getters.getConfirmacionData(state)();
    expect(result).toEqual({
      cliente: {
        emailContacto: "",
        telContacto: {
          caracteristica: "3815",
          nro: "3838",
          interno: "",
          area: "11"
        },
        lugarNacimiento: "",
        cuil: "",
        estadoCivil: "5",
        conyuge: {
          tipoDocumento: "00",
          numeroDocumento: "",
          apellido: "",
          nombre: "",
          nacionalidad: ""
        },
        domicilio: {
          calle: "",
          numero: "",
          piso: "",
          depto: "",
          codigoPostal: "",
          localidad: "",
          codProvincia: "01",
          referencia: ""
        },
        domAlternativo: {
          calle: "",
          numero: "",
          piso: "",
          depto: "",
          codigoPostal: "",
          localidad: "",
          codProvincia: "01",
          referencia: ""
        },
        situacionLaboral: "001",
        tipoActividad: "47",
        tipoCuil: "49",
        tipoOcupacion: "07",
        tipoPagoTarjeta: "1",
        marcaPEP: false,
        marcaSujetoObligado: false,
        constanciaSujetoObligado: false,
        actividadSujetoObligado: "",
        eResumen: "mockResumenDigital",
        eResumenEmail: ""
      },
      deviceId: "mocksDeviceId",
      deviceIdTimestamp: "mocksDeviceIdTimestamp",
      producto: {
        solicitudSucursal: "0999"
      },
      randomKey: "randomKey"
    });
  });

  it("getConfirmacionData returns correct value por domAlternativo", () => {
    const state = {
      consulta: {
        email: "getterEmail",
        celular: {
          area: "11",
          numero: "99998888",
          normalizado: {
            caracteristica: "9999",
            nro: "8888",
            area: "11",
            interno: ""
          }
        }
      },
      paso1: {
        lugarNacimiento: "getterNacimiento",
        estadoCivil: "5",
        conyuge: {
          nombre: "getterNombreConyuge",
          apellido: "getterApellidoConyuge",
          tipoDoc: "00",
          numeroDoc: "88777999"
        },
        domicilioParticular: {
          calle: "getterCalleParticular",
          numero: "getterNumeroParticular",
          piso: "getterPisoParticular",
          dpto: "getterDPTOParticular",
          codigoPostal: "0011",
          localidad: "",
          codProvincia: "01",
          valido: null
        }
      },
      paso2: {
        situacionLaboral: "001",
        actividad: "47",
        ocupacion: "07",
        cuil: "88-12345678-9",
        tipoCuil: "49"
      },
      paso3: {
        pep: "",
        sujetoObligado: "",
        actividadSujetoObligado: ""
      },
      paso4: {
        tipoPago: "minimo",
        selectDomicilio: "otro",
        sucursal: "1",
        email: "getterEmail",
        resumenDigital: "getterResumenDigital",
        otroDomicilio: {
          calle: "getterCalleAlternativa",
          numero: "getterNumeroAlternativo",
          piso: "getterPisoAlternativo",
          dpto: "getterDPTOAlternativo",
          codigoPostal: "0055",
          localidad: "",
          codProvincia: "01",
          valido: null
        }
      },
      deviceId: "getterDeviceId",
      deviceIdTimestamp: "getterDevidIdTimestamp",
      dataOferta: {
        randomkey: "getterRandomKey"
      }
    };
    const result = getters.getConfirmacionData(state)();
    expect(result).toEqual({
      cliente: {
        emailContacto: "getterEmail",
        telContacto: {
          caracteristica: "9999",
          nro: "8888",
          interno: "",
          area: "11"
        },
        lugarNacimiento: "getterNacimiento",
        cuil: "88-12345678-9",
        estadoCivil: "5",
        conyuge: {
          tipoDocumento: "00",
          numeroDocumento: "88777999",
          apellido: "getterApellidoConyuge",
          nombre: "getterNombreConyuge",
          nacionalidad: ""
        },
        domicilio: {
          calle: "getterCalleParticular",
          numero: "getterNumeroParticular",
          piso: "getterPisoParticular",
          depto: "getterDPTOParticular",
          codigoPostal: "0011",
          localidad: "",
          codProvincia: "01",
          referencia: ""
        },

        domAlternativo: {
          calle: "getterCalleAlternativa",
          numero: "getterNumeroAlternativo",
          piso: "getterPisoAlternativo",
          depto: "getterDPTOAlternativo",
          codigoPostal: "0055",
          localidad: "",
          codProvincia: "01",
          referencia: ""
        },
        situacionLaboral: "001",
        tipoActividad: "47",
        tipoCuil: "49",
        tipoOcupacion: "07",
        tipoPagoTarjeta: "0",
        marcaPEP: false,
        marcaSujetoObligado: false,
        constanciaSujetoObligado: false,
        actividadSujetoObligado: "",
        eResumen: "getterResumenDigital",
        eResumenEmail: "getterEmail"
      },
      deviceId: "getterDeviceId",
      deviceIdTimestamp: "getterDevidIdTimestamp",
      producto: {
        solicitudSucursal: "0001"
      },
      randomKey: "getterRandomKey"
    });
  });
  it("getEnvioSms returns correct value", () => {
    const result = getters.getEnvioSms(state)();
    expect(result).toEqual(state.envioSms);
  });

  it("getDatosPersonales returns correct value", () => {
    const result = getters.getDatosPersonales(state)();
    expect(result).toEqual(state.datosPersonales);
  });

  it("getDatosLaborales returns correct value", () => {
    const result = getters.getDatosLaborales(state)();
    expect(result).toEqual(state.datosLaborales);
  });

  it("getDomicilio returns correct value", () => {
    const result = getters.getDomicilio(state)();
    expect(result).toEqual(state.domicilio);
  });

  it("getDomicilio returns correct value tDomic PCG7-TDOMIC-CORRESPONDENCIA", () => {
    const result = getters.getDomicilio(state)(PCG7.TDOMIC.CORRESPONDENCIA);
    expect(result).toEqual(state.domicilioAlternativo);
  });

  it("getLocalidadesAgregadasByCodProv returns correct value", () => {
    const result = getters.getLocalidadesAgregadasByProv(state)("01");
    expect(result).toEqual(state.localidadesAgregadas["01"]);
  });

  it("getInformacionAdicional returns correct value", () => {
    const result = getters.getInformacionAdicional(state)();
    expect(result).toEqual(state.informacionAdicional);
  });

  it("getIdentidad returns correct value", () => {
    const result = getters.getIdentidad(state)();
    expect(result).toEqual(state.identidad);
  });

  it("getKeyLoginVeridas returns correct value", () => {
    const result = getters.getKeyLoginVeridas(state)();
    expect(result).toEqual(state.dataVeridas.key);
  });

  it("getDeviceId returns correct value", () => {
    const result = getters.getDeviceId(state)();
    expect(result).toEqual(state.deviceId);
  });

  it("getDeviceIdTimestamp returns correct value", () => {
    const result = getters.getDeviceIdTimestamp(state)();
    expect(result).toEqual(state.deviceIdTimestamp);
  });

  it("getNumeroCliente returns correct value", () => {
    const result = getters.getNumeroCliente(state)();
    expect(result).toEqual(state.oferta.numeroCliente);
  });

  it("getErrorVeridas returns correct value", () => {
    const result = getters.getErrorVeridas(state)();
    expect(result).toEqual(state.errorVeridas);
  });

  it("getConfiguracion returns correct value", () => {
    const result = getters.getConfiguracion(state)();
    expect(result).toEqual(state.configuracion);
  });

  it("getResultVeridas returns correct value", () => {
    const result = getters.getResultVeridas(state)();
    expect(result).toEqual(state.getResultVeridas);
  });

  it("getConfirmacionDataVeridas returns correct value", () => {
    const result = getters.getConfirmacionDataVeridas(state)();
    expect(result).toEqual({
      cliente: {
        actividadSujetoObligado: "",
        constanciaSujetoObligado: false,
        conyuge: {
          apellido: "",
          nacionalidad: "",
          nombre: "",
          numeroDocumento: "",
          tipoDocumento: "00"
        },
        cuil: "",
        domAlternativo: {
          calle: "",
          codProvincia: "01",
          codigoPostal: "",
          depto: "",
          localidad: "",
          numero: "",
          piso: "",
          referencia: ""
        },
        domicilio: {
          calle: "",
          codProvincia: "01",
          codigoPostal: "",
          depto: "",
          localidad: "",
          numero: "",
          piso: "",
          referencia: ""
        },
        eResumen: true,
        emailContacto: "",
        estadoCivil: "5",
        gclidGoogle: undefined,
        idGoogle: undefined,
        lugarNacimiento: "",
        marcaPEP: false,
        marcaSujetoObligado: false,
        modo: "CD",
        situacionLaboral: "001",
        telCompania: undefined,
        telContacto: {
          caracteristica: "3815",
          nro: "3838",
          area: "11",
          interno: ""
        },
        tipoActividad: "47",
        tipoCuil: "49",
        tipoOcupacion: "07"
      },
      deviceId: "mocksDeviceId",
      deviceIdTimestamp: "mocksDeviceIdTimestamp",
      hashref: undefined,
      producto: {
        modo: "CD",
        solicitudSucursal: "0999"
      },
      randomKey: "randomKey",
      verificationProcessId: "dvs-id"
    });
  });

  it("getContractsPdf returns correct value", () => {
    const result = getters.getContractsPdf(state)();
    expect(result).toEqual(state.dataVeridas.contracts);
  });

  it("getContrato returns correct value", () => {
    const result = getters.getContrato(state)();
    expect(result).toEqual(state.contrato);
  });

  it("getNumeroTramite returns correct value", () => {
    const result = getters.getNumeroTramite(state)();
    expect(result).toEqual(state.configuracion.numeroTramite);
  });

  it("getRandomKey returns correct value", () => {
    const result = getters.getRandomKey(state)();
    expect(result).toEqual(state.dataOferta.randomkey);
  });

  it("getCuenta returns correct value", () => {
    const result = getters.getCuenta(state)();
    expect(result).toEqual(state.cuenta);
  });
  it("getCelular returns correct value", () => {
    const result = getters.getCelular(state)();
    expect(result).toEqual(state.celular);
  });
  it("getCelularNormalizado returns correct value", () => {
    const result = getters.getCelularNormalizado(state)();
    expect(result).toEqual(state.consulta.celular.normalizado);
  });
  it("getDeviceUdid returns correct value", () => {
    const result = getters.getDeviceUdid(state)();
    expect(result).toEqual(state.celular.deviceUdid);
  });
  it("getUsuarioClave returns correct value", () => {
    const result = getters.getUsuarioClave(state)();
    expect(result).toEqual(state.usuarioClave);
  });
  it("getValidandoDomicilio returns correct value", () => {
    const result = getters.getValidandoDomicilio(state)();
    expect(result).toEqual(state.validandoDomicilio);
  });
  it("getDataAuthASO returns correct value", () => {
    const result = getters.getDataAuthASO(state)();
    expect(result).toEqual(state.dataAuthASO);
  });

  it("getVeridasId returns correct value", () => {
    const result = getters.getVeridasId(state)();
    expect(result).toEqual(state.DVSIframeData.id);
  });
});
